import React from 'react';
import dayjs from 'dayjs';
import Modal from '@/components/modal/Modal';
import { RegularText, MediumText, DemiLightText } from '@/lib/Text';
import { Col, Row } from '@/lib/utils';
import { colors } from '@/lib/colors';

interface ModalNoticePreviewProps {
    title: string;
    content: string;
    imageUrls: string[];
    onClose: () => void;
    onEdit: () => void;
    onSubmit: () => void;
}

const ModalNoticePreview = ({ title, content, imageUrls, onClose, onEdit, onSubmit }: ModalNoticePreviewProps) => {
    const today = dayjs().format('YYYY.MM.DD (dd)');

    return (
        <Modal
            whiteViewWidth={640}
            borderRadius={39}
            onClose={onClose}
            isCloseButton={true}
            isCloseOutside
            modalAlign="center"
            heightFull={false}
            isWhiteOverFlowScroll={false}
            mt={90}
            mb={150}
        >
            <Col className="w-full">
                {/* Header */}
                <Row className="justify-between items-center px-[41px] pt-[42px] pb-[28px]">
                    <Row className="items-center gap-[12px]">
                        <MediumText fontSize={25} lineHeight={34} color={colors.Text_1} letterSpacing={-0.5}>
                            미리 보기
                        </MediumText>
                        <DemiLightText fontSize={14} lineHeight={21} color="#6E7375" letterSpacing={-0.5}>
                            * 회원 핸드폰 기종에 따라 다르게 보여질 수 있어요.
                        </DemiLightText>
                    </Row>
                </Row>

                {/* Preview Card */}
                <div className="mx-[40px] mb-[34px] border border-[#E6E8EA] border-solid rounded-[33px]">
                    <div className="px-[58px] py-[38px]">
                        {/* Title & Date */}
                        <div className="mb-[9px]">
                            <MediumText fontSize={18} lineHeight={28} letterSpacing={-0.3} color="#191F28">
                                {title || '제목을 입력해주세요.'}
                            </MediumText>
                        </div>
                        <RegularText fontSize={14} lineHeight={21} color={colors.Text_1} letterSpacing={-0.5}>
                            {today}
                        </RegularText>

                        {/* Divider */}
                        <div className="w-full h-[1px] bg-[#E8EAED] my-[24px]" />

                        {/* Images */}
                        {imageUrls.length > 0 && (
                            <div className="flex flex-col gap-[12px] mb-[24px]">
                                {imageUrls.map((url, index) => (
                                    <img
                                        key={index}
                                        src={url}
                                        alt={`미리보기 이미지 ${index + 1}`}
                                        className="w-full rounded-[8px] object-cover"
                                    />
                                ))}
                            </div>
                        )}

                        {/* Content */}
                        <div className="whitespace-pre-wrap break-words">
                            <RegularText fontSize={14} lineHeight={26} color={colors.Text_1} letterSpacing={-0.4}>
                                {content || '내용을 입력해주세요.'}
                            </RegularText>
                        </div>
                    </div>
                </div>

                {/* Footer Buttons */}
                <Row className="px-[40px] pb-[36px] gap-[18px]">
                    <button
                        className="flex-1 h-[62px] rounded-[12px] flex items-center justify-center hover:bg-[#F4F5F7] transition-colors bg-[#F2F4F6]"
                        onClick={onClose}
                    >
                        <RegularText fontSize={20} lineHeight={24} letterSpacing={-0.3} color="#4E5968">
                            취소
                        </RegularText>
                    </button>
                    <button
                        className="flex-1 h-[62px] bg-primary rounded-[12px] flex items-center justify-center hover:bg-blue-600 transition-colors"
                        onClick={onSubmit}
                    >
                        <RegularText fontSize={20} lineHeight={24} letterSpacing={-0.3} color="white">
                            등록하기
                        </RegularText>
                    </button>
                </Row>
            </Col>
        </Modal>
    );
};

export default ModalNoticePreview;
